import { gql } from '@apollo/client';

export const CREATE_EMPTY_CHECKOUT = gql`
  mutation CheckoutCreate {
    checkoutCreate(input: { lineItems: [] }) {
      checkout {
        id
      }
      errors: checkoutUserErrors {
        code
        field
        message
      }
    }
  }
`;

export const UPDATE_CHECKOUT_ITEMS = gql`
  mutation CheckoutLineItemsReplace(
    $lineItems: [CheckoutLineItemInput!]!
    $checkoutId: ID!
  ) {
    checkoutLineItemsReplace(lineItems: $lineItems, checkoutId: $checkoutId) {
      checkout {
        id
        lineItems(first: 1) {
          edges {
            node {
              id
              quantity
              title
            }
          }
        }
      }
      errors: userErrors {
        code
        message
      }
    }
  }
`;

export const GET_CHECKOUT = gql`
  query GetCheckout(
    $checkoutId: ID!
    $pageSize: Int = 100
    $offset: String = null
  ) {
    node(id: $checkoutId) {
      ... on Checkout {
        lineItems(first: $pageSize, after: $offset) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          edges {
            cursor
            node {
              id
              variant {
                id
              }
              quantity
            }
          }
        }
      }
    }
  }
`;
